import { useApiScope } from '../../scope';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';
import { FormsTemplateResponse } from './types';

export const useFormsTemplate = (templateId: string | null | undefined) => {
  const { shareToken } = useApiScope();
  const url = templateId ? `${BASE_URL}/${templateId}` : null;

  const { data, error, isLoading, mutate } = useSWR<FormsTemplateResponse>(
    url,
    SWRFetcher({
      method: 'GET',
      shareToken,
    })
  );

  return {
    data,
    error,
    isLoading,
    mutate,
    template: data?.formsTemplate ?? null,
  };
};
